// Utilities for handling weekly survey reminder snooze/suppress state

const SNOOZE_KEY = 'survey:snoozeUntil';

export const getWeekKey = (weekStart) => {
  try {
    if (!weekStart) return null;
    const d = new Date(weekStart);
    if (Number.isNaN(d.getTime())) return null;
    return d.toISOString().slice(0, 10); // YYYY-MM-DD
  } catch {
    return null;
  }
};

export const isDismissedForWeek = (weekKey) => {
  if (!weekKey) return false;
  return localStorage.getItem(`survey:dismissedWeek:${weekKey}`) === '1';
};

export const dismissForWeek = (weekKey) => {
  if (!weekKey) return;
  try { localStorage.setItem(`survey:dismissedWeek:${weekKey}`, '1'); } catch {}
};

export const isSnoozed = () => {
  try {
    const ts = parseInt(localStorage.getItem(SNOOZE_KEY) || '0', 10);
    if (!ts) return false;
    return Date.now() < ts;
  } catch {
    return false;
  }
};

export const snoozeHours = (hours) => {
  try {
    const until = Date.now() + Math.max(1, hours) * 60 * 60 * 1000;
    localStorage.setItem(SNOOZE_KEY, String(until));
  } catch {}
};

export const clearSnooze = () => {
  try { localStorage.removeItem(SNOOZE_KEY); } catch {}
};
